export default __webpack_public_path__ + "static/media/progress-3.be4dd0d6.svg";